<div class="form-row">
  <div class="form-group col-md-6">
    <label>Name</label>
    <input type="text" name='name' [(ngModel)]='this.warehouse.name' [class.is-invalid]='!this.warehouse.name' class="form-control">
  </div>
  <div class="form-group col-md-12">
    <label>Description</label>
    <textarea name='description' [(ngModel)]="this.warehouse.description" class="form-control"></textarea>
  </div>
</div>
